import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/login/apple.png';
var _hoisted_1 = {
  key: 0,
  class: "apple-button-wrap"
};
import appleSignInHelper from "@/utils/appleSignInHelper";
import { checkPlatform } from "@/utils/tools";
import { onMounted } from "vue";
export default {
  __name: 'AppleSignInButton',
  emits: ["success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var isIOS = checkPlatform("ios");
    var init = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return appleSignInHelper.init({
                clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
                onSuccess: function onSuccess(data) {
                  emit("success", data);
                },
                onError: function onError(error) {
                  console.error("apple sign in init error", error);
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function init() {
        return _ref2.apply(this, arguments);
      };
    }();
    var signInApple = function signInApple() {
      appleSignInHelper.signIn();
    };
    onMounted(function () {
      init();
    });
    return function (_ctx, _cache) {
      return _unref(isIOS) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "apple-sign-in-button",
        onClick: signInApple
      }, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "button-wrap-icon",
        src: _imports_0
      }, null, -1)), _createTextVNode(_toDisplayString(_ctx.$t("continueWithApple")), 1)])])) : _createCommentVNode("", true);
    };
  }
};